import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { productTypes } from '../types/products';

import { TranslatedCopy } from '../intl';
import { H3, Currency, SpacerDot, ProductGenderDivision } from '../components';
import ProductImage from '~COMPONENTS/aurora/ProductImage';

import { formatColorString } from '../util/formatColorString';

import { VALUE_NA } from '../shop/constants';

import { getIsGreaterChinaSalesOrg } from '../gamedayAccount/selectors';

export const LineItemHeaderPF = ({
  product: {
    copy,
    styleGenderAge,
    division,
    productCode,
    colorName,
    rawName,
    retailAmount,
    wholesaleAmount,
    totalNet,
    totalQty,
    isGreaterChinaSalesOrg
  },
  currencyCode,
  paymentMethod,
  baseClass
}) => {
  const title = (copy && copy.name) || VALUE_NA;

  return (
    <div className='u-full-width flex-container row start'>
      <div className={`${baseClass}__lineItem_img`}>
        <ProductImage alt={title} productCode={productCode} />
      </div>
      <div className='u-full-width flex-container column start body-4 ml4-sm text-color-secondary'>
        <div className='body-4 text-uppercase u-bold' data-desc={copy && copy.name}>
          {title}
        </div>
        <p className='text-color-secondary body-3 print_fontSize_two'>{rawName}</p>
        <ul className='text-color-secondary'>
          <li>
            <ProductGenderDivision gender={styleGenderAge} division={division} />
          </li>
          <li>
            <TranslatedCopy id='global.product.style' />:{productCode}
          </li>
          <li>
            <TranslatedCopy id='global.product.color' />:{formatColorString(colorName)}
          </li>
          <li>
            {!isGreaterChinaSalesOrg && (
              <>
                <TranslatedCopy id='global.product.retail' />{' '}
                <Currency value={retailAmount || '0'} type={currencyCode || 'USD'} /> <SpacerDot />{' '}
              </>
            )}
            <TranslatedCopy id='global.wholesale' />{' '}
            <Currency value={wholesaleAmount || '0'} type={currencyCode || 'USD'} />
          </li>
        </ul>
      </div>
      <div className='text-color-primary-dark u-full-width ta-sm-r'>
        <H3>
          <TranslatedCopy id='orderreturns.totalQuantity' />:{totalQty}
        </H3>
        <H3>
          <TranslatedCopy id='global.total' />
          :
          <Currency value={totalNet || '0'} type={currencyCode || 'USD'} />
        </H3>
        <p className='orderDetails__print_font u-bold text-color-secondary'>{paymentMethod}</p>
      </div>
    </div>
  );
};

LineItemHeaderPF.propTypes = {
  product: productTypes.isRequired,
  currencyCode: PropTypes.string,
  paymentMethod: PropTypes.string,
  baseClass: PropTypes.string.isRequired,
  isGreaterChinaSalesOrg: PropTypes.bool.isRequired
};

LineItemHeaderPF.defaultProps = {
  currencyCode: null,
  paymentMethod: ''
};

const mapStateToProps = state => ({
  isGreaterChinaSalesOrg: getIsGreaterChinaSalesOrg(state)
});

export default connect(mapStateToProps, {})(LineItemHeaderPF);
